export const sortArray = (array, property) => {
    return [...array].sort((a, b) => {
        const valueA = a[property].join('').toLowerCase();
        const valueB = b[property].join('').toLowerCase();
        return valueA.localeCompare(valueB);
    });
};
